module.exports = __webpack_public_path__ + "static/media/img02.5bc7b3ce.svg";


//////////////////
// WEBPACK FOOTER
// ./src/content/chapters/02/03/components/c02_a03_tab_02/assets/img02.svg
// module id = 445
// module chunks = 0